import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, pluck, tap } from 'rxjs/operators';
import { FuelEUType } from '../models/fueleu';

@Injectable({
  providedIn: 'root'
})
export class FueleuTypesService {
  FuelEUTypeList: BehaviorSubject<FuelEUType[]> = new BehaviorSubject<FuelEUType[]>([])
  FuelEUTypeList$: Observable<FuelEUType[]> = this.FuelEUTypeList.asObservable()

  private _url: string = `${environment.apiUrl}/api/FuelTypes/`
  constructor(private http: HttpClient) { }

  getfuelTypes() {
    return this.http.get(this._url).pipe(map((res: any) => res.data), tap((data: FuelEUType[]) => this.FuelEUTypeList.next(data)))
  }

  createFuelEUType(FuelEUType: FuelEUType) {
    return this.http.post(this._url, FuelEUType)
  }

  getFuelEUType(id: string) {
    return this.http.get(this._url + id)
  }

  updateFuelEUType(id: string, FuelEUType: FuelEUType) {
    return this.http.put(this._url + id, FuelEUType)
  }

  deleteFuelEUType(id: string) {
    return this.http.delete(this._url + id)
  }
}
